// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__5uW41","list":"BalanceDue_list__2_NpA","listRow":"BalanceDue_listRow__3qbqu","total":"BalanceDue_total__3rEh_"};